import { TownsquareSiteAri } from '@atlassian/ari/townsquare';

/**
 * Creates a Townsquare site ARI from a container ID
 * @param containerId - The container/site ID
 * @returns The site ARI string, or empty string if creation fails
 */
export const getSiteAri = (containerId: string): string => {
	// we wrap in a try/catch incase there are any issues with creating the site ari
	try {
		return TownsquareSiteAri.create({
			siteId: containerId,
		}).toString();
	} catch {
		return '';
	}
};
